import { schema } from "normalizr";

const CompanySchema = new schema.Entity("companies");

export { 
  CompanySchema
};